export const BILLS_PENDING = "BILLS_PENDING"
export const BILLS_SUCCESS = "BILLS_SUCCESS"
export const BILLS_FAILURE = "BILLS_FAILURE"

export const GET_HARDWARE_SHOPS_NAME_PENDING = "GET_HARDWARE_SHOPS_NAME_PENDING"
export const GET_HARDWARE_SHOPS_NAME_SUCCESS = "GET_HARDWARE_SHOPS_NAME_SUCCESS"
export const GET_HARDWARE_SHOPS_NAME_FAILURE = "GET_HARDWARE_SHOPS_NAME_FAILURE"

export const ADD_HARDWARE_SHOPS_BILLS_PENDING =
  "ADD_HARDWARE_SHOPS_BILLS_PENDING"
export const ADD_HARDWARE_SHOPS_BILLS_SUCCESS =
  "ADD_HARDWARE_SHOPS_BILLS_SUCCESS"
export const ADD_HARDWARE_SHOPS_BILLS_FAILURE =
  "ADD_HARDWARE_SHOPS_BILLS_FAILURE"

export const UPLOAD_HARDWARE_SHOPS_BILLS_PENDING =
  "UPLOAD_HARDWARE_SHOPS_BILLS_PENDING"
export const UPLOAD_HARDWARE_SHOPS_BILLS_SUCCESS =
  "UPLOAD_HARDWARE_SHOPS_BILLS_SUCCESS"
export const UPLOAD_HARDWARE_SHOPS_BILLS_FAILURE =
  "UPLOAD_HARDWARE_SHOPS_BILLS_FAILURE"

export const EDIT_HARDWARE_SHOPS_BILLS_PENDING =
  "EDIT_HARDWARE_SHOPS_BILLS_PENDING"
export const EDIT_HARDWARE_SHOPS_BILLS_SUCCESS =
  "EDIT_HARDWARE_SHOPS_BILLS_SUCCESS"
export const EDIT_HARDWARE_SHOPS_BILLS_FAILURE =
  "EDIT_HARDWARE_SHOPS_BILLS_FAILURE"

export const DELETE_HARDWARE_SHOPS_BILLS_PENDING =
  "DELETE_HARDWARE_SHOPS_BILLS_PENDING"
export const DELETE_HARDWARE_SHOPS_BILLS_SUCCESS =
  "DELETE_HARDWARE_SHOPS_BILLS_SUCCESS"
export const DELETE_HARDWARE_SHOPS_BILLS_FAILURE =
  "DELETE_HARDWARE_SHOPS_BILLS_FAILURE"

export const DOWNLOAD_HARDWARE_SHOPS_BILLS_PENDING =
  "DOWNLOAD_HARDWARE_SHOPS_BILLS_PENDING"
export const DOWNLOAD_HARDWARE_SHOPS_BILLS_SUCCESS =
  "DOWNLOAD_HARDWARE_SHOPS_BILLS_SUCCESS"
export const DOWNLOAD_HARDWARE_SHOPS_BILLS_FAILURE =
  "DOWNLOAD_HARDWARE_SHOPS_BILLS_FAILURE"
